const TAB_URL = "tab_url";
const WAREHOUSE_URL = "warehouse_url";

export const initiateTabUrl = () => {
  localStorage.removeItem(TAB_URL);
};

export const initiateWarehouseUrl = () => {
  localStorage.removeItem(WAREHOUSE_URL);
};

export const setTabUrl = (type: string) => {
  localStorage.setItem(TAB_URL, type);
  if (
    type === "ypo" ||
    type === "yarn" ||
    type === "orderhead" ||
    type === "orderstyle" ||
    type === "booking"
  ) {
    localStorage.setItem(TAB_URL, "yarn");
  } else if (type === "apo" || type === "accessory") {
    localStorage.setItem(TAB_URL, "accessory");
  } else if (type === "lsppo" || type === "lsp" || type === "lycra") {
    localStorage.setItem(TAB_URL, "lycra");
  }
};

export const setWarehouseUrl = (type: string) => {
  localStorage.setItem(WAREHOUSE_URL, type);
  if (type === "yarn") {
    localStorage.setItem(WAREHOUSE_URL, "yarn");
  } else if (type === "accessory") {
    localStorage.setItem(WAREHOUSE_URL, "accessory");
  }
};




export const getWarehouseUrl = (): string => {
  return localStorage.getItem(WAREHOUSE_URL) ?? "yarn";
};
